

















































































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class FixedNav extends Vue {
  is_scrolled = false;
  is_scroll_ready = false;

  private handleScroll = () => {
    this.onScroll();
  };

  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.onScroll();
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  onScroll() {
    if (this.is_scroll_ready) {
      return;
    }

    this.is_scroll_ready = true;

    window.requestAnimationFrame(() => {
      this.is_scrolled = window.scrollY > 100;
      this.is_scroll_ready = false;
    });
  }
}
